import React from "react";
import { Stack } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import "./ProcessingFeeInfo.scss";
import BottomDrawer from "../../BottomDrawer/BottomDrawer";
import { GenericModalProps } from "../../../utils/constants/generic-types";
import PrimaryActionButton from "../../Buttons/PrimaryActionButton/PrimaryActionButton";

export default function ProcessingFeeInfo({
  isOpen,
  onClose,
}: GenericModalProps) {
  const { t } = useTranslation("wallet");
  return (
    <BottomDrawer
      isOpen={isOpen}
      onClose={onClose}
      showCloseBtn={false}
      containerClass="ProcessingFeeInfoModal"
      backdropClassName="ProcessingFeeInfoModalOverlay"
    >
      <Stack gap={4}>
        <h3 className="text-center text-capitalize text Hanson-700 Title">
          {t("processing_fee")}
        </h3>
        <p className="Grotesk Info">
          {t("processing_fee_is_determined_by_our_payment_partners")}
        </p>
      </Stack>
      <PrimaryActionButton
        size="lg"
        text={t("common:got_it")}
        onClick={onClose}
        buttonClassName="PrimaryButton"
      />
    </BottomDrawer>
  );
}
